import firebase from "firebase/compat/app";
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCqMUCYDWLJtSvd0OiZvIbyunMlwyxiVUY",
  authDomain: "cnd-tech.firebaseapp.com",
  projectId: "cnd-tech",
  storageBucket: "cnd-tech.appspot.com",
  messagingSenderId: "774538055416",
  appId: "1:774538055416:web:676f9fdc432f66898cf50d",
  measurementId: "G-KE586SBNX9"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

export default firebaseApp.firestore();
